import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { tAppDispatch, tAppState } from '../rootStore';

export function useTypedDispatch(): tAppDispatch {
  return useDispatch<tAppDispatch>();
}

export const useTypedSelector: TypedUseSelectorHook<tAppState> = useSelector;
